// "Your Account / ..." breadcrumbs shared by the sealy account pages
// (AccountBreadcrumbShell, OrderHistoryPageBody, OrderDetailPageBody). Crumbs
// render as links when they carry an href, plain text otherwise, joined by
// " / " like the legacy breadcrumbs markup.
import { Immutable } from "immer";
import React from "react";

import styles from "./index.module.scss";

export type ICrumb = Immutable<{
    label: string;
    href?: string;
}>;

type IProps = Immutable<{
    crumbs: ICrumb[];
}>;

export const AccountBreadcrumbs = (props: IProps): React.JSX.Element => (
    <section
        className={styles.breadcrumbsBlock}
        data-testid="account-breadcrumbs"
    >
        {props.crumbs.map((crumb, i) => (
            <React.Fragment key={i}>
                {i > 0 && " / "}
                {crumb.href ? (
                    <a href={crumb.href}>{crumb.label}</a>
                ) : (
                    crumb.label
                )}
            </React.Fragment>
        ))}
    </section>
);
